// extracted by mini-css-extract-plugin
export var activityContainer = "_jl-0";
export var typingIndicatorContainer = "_jl-1";
export var typingIndicatorDot = "_jl-2";
export var wave = "_jl-3";